export default "__VITE_ASSET__fc193396__"